import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { galleryImages } from '@/mocks/homeData';

export default function GallerySection() {
  const ref = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.unobserve(el); } },
      { threshold: 0.08 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-6">
        <div className={`flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4 anim-fade-up ${isVisible ? 'is-visible' : ''}`}>
          <div className="text-center md:text-left">
            <span className="inline-block text-xs font-bold tracking-widest text-[#C9A84C] uppercase border border-[#C9A84C]/40 rounded-sm px-3 py-1 mb-4">Gallery</span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-[#1B3A6B]">수강생 포트폴리오</h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs leading-relaxed text-center md:text-right mx-auto md:mx-0">전문 강사진의 지도 아래 완성된 실제 작품들입니다</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {galleryImages.map((item, i) => (
            <div
              key={item.id}
              className={`group relative rounded-xl overflow-hidden cursor-pointer border border-gray-100 anim-scale-up ${isVisible ? 'is-visible' : ''}`}
              style={{ transitionDelay: isVisible ? `${i * 70}ms` : '0ms' }}
            >
              <div className="w-full h-40 sm:h-56 md:h-72">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B3A6B]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4 md:p-5">
                <span className="inline-block bg-[#C9A84C] text-white text-xs font-bold px-3 py-1 rounded-sm mb-2 w-fit">{item.category}</span>
                <p className="text-white font-bold text-sm">{item.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center mt-10 md:mt-12 anim-fade-up ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: isVisible ? '500ms' : '0ms' }}>
          <Link to="/community" className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md border-2 border-[#1B3A6B] text-[#1B3A6B] font-bold hover:bg-[#1B3A6B] hover:text-white transition-all cursor-pointer w-full sm:w-auto">
            갤러리 전체 보기 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
